import { NavLink, useLocation } from 'react-router-dom';
import { LayoutDashboard, ClipboardList, BoxesIcon, Package } from 'lucide-react';
import { cn } from '@/lib/utils';

const OPS_TABS = [
  { to: '/dashboard', icon: LayoutDashboard, label: 'Dashboard', exact: true },
  { to: '/work-orders', icon: ClipboardList, label: 'Work Orders' },
  { to: '/containers', icon: BoxesIcon, label: 'Containers' },
  { to: '/assets', icon: Package, label: 'Assets' },
];

export default function OperationsSubNav() {
  const location = useLocation();
  const isActive = (path: string, exact?: boolean) =>
    exact ? location.pathname === path : location.pathname.startsWith(path);

  return (
    <nav className="sticky top-14 z-30 flex items-center gap-1 border-b border-border bg-muted/30 px-4 overflow-x-auto backdrop-blur-sm">
      {OPS_TABS.map((tab) => (
        <NavLink
          key={tab.to}
          to={tab.to}
          className={cn(
            'flex items-center gap-1.5 whitespace-nowrap border-b-2 px-3 py-2 text-sm font-medium transition-colors',
            isActive(tab.to, tab.exact)
              ? 'border-primary text-primary'
              : 'border-transparent text-muted-foreground hover:border-border hover:text-foreground'
          )}
        >
          <tab.icon className="h-4 w-4" />
          {tab.label}
        </NavLink>
      ))}
    </nav>
  );
}
